import React from 'react';

import { GUID, Portfolio, SettlementType } from '@ndvr/billing-api';

import { AccountNameLink, Text } from 'widgets';

interface Props {
    settlementType: SettlementType;
    portfolioGUID?: GUID<Portfolio>;
}

export const SettlementTitle = ({ settlementType, portfolioGUID }: Props) => {
    switch (settlementType) {
        case SettlementType.DEFAULT_SETTLEMENT:
            return <Text largeBody>Default settlement</Text>;
        case SettlementType.SETTLED_BY_PORTFOLIO:
        case SettlementType.SETTLED_BY_EXTERNAL_PORTFOLIO:
            return <AccountNameLink accountGUID={portfolioGUID!} />;
        default:
            return <Text largeBody>Unknown method</Text>;
    }
};
